.root {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  // Pen `oomtC` outer bar: #F1F5F9 fill, padding [4,6,0,6].
  padding: 4px 6px 0;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
}

.tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 8px 6px;
  border: none;
  border-radius: 8px 8px 0 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.tab-is-active {
  background: #ffffff;
}

.tab-status-missing:not(.tab-is-active) {
  background: #fffbeb;
}

// Default icon tint follows the inactive tab. Active tab gets the brand
// accent; warning tabs swap to amber so the alert reads cleanly.
.icon {
  color: #94a3b8;
  flex: none;
}

.tab-is-active .icon {
  color: #8b5cf6;
}

.tab-status-missing .icon {
  color: #d97706;
}

.tab-label {
  font-size: 9px;
  font-weight: 600;
  color: #64748b;
  text-align: center;
}

.tab-is-active .tab-label {
  font-weight: 700;
  color: #0f172a;
}

.tab-status-missing .tab-label {
  color: #b45309;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 8px;
  font-weight: 600;
}

.pill-status-complete {
  background: #ecfdf5;
  color: #059669;
}

.pill-status-partial,
.pill-status-missing {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #b45309;
}

.indicator {
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background: transparent;
}

.indicator-is-active {
  background: #7c3aed;
}
